import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../store";

export type LinkPreviewState = {
  iFrameError: boolean;
  iFrameLoaded: boolean;
};

//state to be used by other link preview components
const initialState = {
  iFrameError: false,
  iFrameLoaded: false,
} as LinkPreviewState;

export const linkPreviewSlice = createSlice({
  name: "linkPreview",
  initialState,
  reducers: {
    resetIFrameState: (state: LinkPreviewState) => {
      state.iFrameError = false;
      state.iFrameLoaded = false;
    },
    setIframeError: (state: LinkPreviewState) => {
      state.iFrameError = true;
      state.iFrameLoaded = false;
    },
    setIframeLoaded: (state: LinkPreviewState) => {
      state.iFrameError = false;
      state.iFrameLoaded = true;
    },
  },
});

export const { setIframeError, setIframeLoaded, resetIFrameState } =
  linkPreviewSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectIFrameLoaded = (state: RootState) =>
  state.linkPreview.iFrameLoaded;
export const selectIFrameError = (state: RootState) =>
  state.linkPreview.iFrameError;

export default linkPreviewSlice.reducer;
